export const USER_PROFILE_FEATURE = 'userProfile';
export const USER_PROFILE_CORE_FEATURE = 'userProfileCore';
